import { render, staticRenderFns } from "./BranchDteTemplateEditorPanel.vue?vue&type=template&id=1da36dc3&scoped=true"
import script from "./BranchDteTemplateEditorPanel.vue?vue&type=script&lang=js"
export * from "./BranchDteTemplateEditorPanel.vue?vue&type=script&lang=js"
import style0 from "./BranchDteTemplateEditorPanel.vue?vue&type=style&index=0&id=1da36dc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da36dc3",
  null
  
)

export default component.exports